import {useSelector} from "react-redux";

export const ErrorDataPage = () => {
    const translate = useSelector(state => state.app.translate)
    document.title = translate.error_message
    return (
        <div className="errorPage">
            <div className="errorPage__title">
                {
                    translate.error_message
                }
            </div>
        </div>
    )
}